import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { makeupTtkSchema } from '../schemas';
import axios from "axios";
import ThinksToKnowStatus from './ThinksToKnowStatus';

const BridalmakeupTTK = () => {
    const { language, token, currency } = useUserAuth()
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user } = useUserAuth();
    const merchant_id = user.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [merchant, setMerchant] = useState({});
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const workingSinceOption = checkboxData.workSinceOption;
    const productUsedOption = checkboxData.productUsedOption;
    const Serviceprovidedcityoption = checkboxData.areaOfWorking;
    
    const formik = useFormik({
        initialValues: {
            bridalMakeupPrice: Math.floor(merchant?.bridalMakeupPrice * currency.value) || '',
            airBrushBridalMakeupPrice: Math.floor(merchant?.airBrushBridalMakeupPrice * currency.value) || '',
            partyMakeupPrice: Math.floor(merchant?.partyMakeupPrice * currency.value) || '',
            outStationMakeupCharges: merchant?.outStationMakeupCharges || '',
            engagementMakeupPrice: Math.floor(merchant?.engagementMakeupPrice * currency.value)|| '',
            workingSince: merchant?.workingSince || [],
            productUsed: merchant?.productUsed || [],
            sericeProvided: merchant?.sericeProvided || [],
        },
        enableReinitialize: true,
        validationSchema: makeupTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values,
                          bridalMakeupPrice: Math.floor(values.bridalMakeupPrice * currency.country_value),
                          airBrushBridalMakeupPrice: Math.floor(values.airBrushBridalMakeupPrice * currency.country_value),
                          partyMakeupPrice: Math.floor(values.partyMakeupPrice * currency.country_value),
                          engagementMakeupPrice: Math.floor(values.engagementMakeupPrice * currency.country_value)
                    },
                };
                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });

    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Starting Bridal Makeup Price</th>
                                                            <th style={{ width: '25%' }}>Starting AirBrush Starting Bridal Makeup Price</th>
                                                            <th style={{ width: '25%' }}>Starting Party Makeup for Family Per Person </th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>
                                                            <td>{merchant.bridalMakeupPrice}</td>
                                                            <td>{merchant.airBrushBridalMakeupPrice}</td>
                                                            <td>{merchant.partyMakeupPrice}</td>
                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Starting OutStation Makeup Charges</th>
                                                            <th>Starting Engagement Makeup Price</th>
                                                            <th>Product used</th>
                                                            <th>Area of Services </th>
                                                        </tr>
                                                        <tr>
                                                            <td> {merchant.outStationMakeupCharges}</td>
                                                            <td>&#8377; {merchant.engagementMakeupPrice}</td>
                                                            <td>{
                                                                merchant.productUsed

                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>
                                                            <td>{
                                                                merchant.sericeProvided
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>
                                                        </tr>


                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>

                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Starting Bridal Makeup Price</label>
                                                        <input
                                                            type="number"
                                                            name="bridalMakeupPrice"
                                                            placeholder='Starting Bridal Makeup Price Per Makeup'
                                                            className='form-control'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.bridalMakeupPrice}
                                                        />
                                                        {formik.touched.bridalMakeupPrice && formik.errors.bridalMakeupPrice ? (
                                                            <div className="text-danger">{formik.errors.bridalMakeupPrice}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Starting AirBrush Starting Bridal Makeup Price</label>
                                                        <input
                                                            type="number"
                                                            name="airBrushBridalMakeupPrice"
                                                            placeholder='Starting AirBrush Starting Bridal Makeup Price'
                                                            className='form-control'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.airBrushBridalMakeupPrice}
                                                        />
                                                        {formik.touched.airBrushBridalMakeupPrice && formik.errors.airBrushBridalMakeupPrice ? (
                                                            <div className="text-danger">{formik.errors.airBrushBridalMakeupPrice}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Starting Party Makeup for Family Per Person</label>
                                                        <input
                                                            type='number'
                                                            name="partyMakeupPrice"
                                                            className='form-control'
                                                            placeholder='Party Makeup Price'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.partyMakeupPrice}
                                                        />
                                                        {formik.touched.partyMakeupPrice && formik.errors.partyMakeupPrice ? (
                                                            <div className="text-danger">{formik.errors.partyMakeupPrice}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Starting OutStation Makeup Charges</label>
                                                        <select
                                                            name="outStationMakeupCharges"
                                                            className='form-control'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.outStationMakeupCharges}
                                                        >
                                                            <option value="" label="Select option" />
                                                            <option value="noService" label="No Service" />
                                                            <option value="asPerLocation" label="As Per Location" />
                                                        </select>
                                                        {formik.touched.outStationMakeupCharges && formik.errors.outStationMakeupCharges ? (
                                                            <div className="text-danger">{formik.errors.outStationMakeupCharges}</div>
                                                        ) : null}
                                                    </div>

                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Starting Engagement Makeup Price</label>
                                                        <input
                                                            type='number'
                                                            name="engagementMakeupPrice"
                                                            className='form-control'
                                                            placeholder='Starting Engagement Makeup Price'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.engagementMakeupPrice}
                                                        />
                                                        {formik.touched.engagementMakeupPrice && formik.errors.engagementMakeupPrice ? (
                                                            <div className="text-danger">{formik.errors.engagementMakeupPrice}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Product used</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={productUsedOption}
                                                            selected
                                                            value={formik.values.productUsed}
                                                            onChange={(productUsed) => formik.setFieldValue('productUsed', productUsed)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.productUsed && formik.errors.productUsed ? (
                                                            <div className="text-danger">{formik.errors.productUsed}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Area of Services</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={Serviceprovidedcityoption}
                                                            selected
                                                            value={formik.values.sericeProvided}
                                                            onChange={(sericeProvided) => formik.setFieldValue('sericeProvided', sericeProvided)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.sericeProvided && formik.errors.sericeProvided ? (
                                                            <div className="text-danger">{formik.errors.sericeProvided}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <button type='submit' className='btn btn-primary'>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default BridalmakeupTTK